import alis_logo from "../../img/alis_logo.png"
import ecp_logo from "../../img/ECP_logo.svg"
import pcc_logo from "../../img/pointclickcarelogo.svg"
import becklar_logo from "../../img/becklar_logo.svg"
import residex_logo from "../../img/residex_logo.webp"
import ucc_logo from "../../img/teamucc_logo.png"
import yardi_logo from "../../img/yardi_logo.svg"

const imgMap = {"alis_logo.png": alis_logo,
                     "ECP_logo.svg": ecp_logo,
                     "pointclickcarelogo.svg": pcc_logo,
                     "becklar_logo": becklar_logo,
                     "yardi_logo": yardi_logo,
                     "ucc_logo": ucc_logo,
                     "residex_logo": residex_logo};

export default imgMap;